
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.44.29a.81.81 0 00-.57.24l-7.95 8a2.44 2.44 0 000 3.44l2.4 2.39a1.38 1.38 0 001 .42h10.5a.41.41 0 100-.81h-7.1L16 6.65a.81.81 0 000-1.15l-5-5a.82.82 0 00-.56-.21zm0 .81l5 5-7.86 7.82H5.32a.62.62 0 01-.43-.18l-2.4-2.4a1.62 1.62 0 010-2.29l1.3-1.3L8.07 12a.4.4 0 00.29.12.39.39 0 00.28-.12.41.41 0 000-.58L4.37 7.18zM1.18 13.71a.41.41 0 00-.41.41.4.4 0 00.41.4h1a.4.4 0 00.41-.4.41.41 0 00-.41-.41zm2.49 1.45a.4.4 0 00-.29.12l-.74.72a.41.41 0 00.29.69.38.38 0 00.28-.12l.79-.72a.4.4 0 000-.57.38.38 0 00-.33-.12z","fill":"#515257"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/objectMenu/clear.svg